import { makeStyles, createStyles } from '@material-ui/core/styles';

const ChatWithEveryoneStyles = makeStyles((theme: any) => createStyles({
  chatEveryoneText: {
    fontSize: 14,
    position: "relative",
    textAlign: "left",
    left: 11,
    marginBottom: 10,
  },
})
)

export { ChatWithEveryoneStyles };